import { createHttpClient } from '@adapters/HttpClient';
import { apiClientWH } from '@shared/services/ApiClient';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { ReceptionApiAdapter } from '../adapters/ReceptionApiAdapter';
import { CreateReceptionRequest } from '../models/Reception';
import { ReceptionService } from '../services/ReceptionService';

/**
 * Hook para crear una nueva recepción
 */
export const useCreateReception = () => {
  const queryClient = useQueryClient();
  const httpClient = createHttpClient(apiClientWH);
  const apiAdapter = new ReceptionApiAdapter(httpClient);
  const receptionService = new ReceptionService(apiAdapter);

  return useMutation({
    mutationFn: (data: CreateReceptionRequest) =>
      receptionService.createReception(data),
    onSuccess: () => {
      // Invalidar queries de lista para refrescar datos
      queryClient.invalidateQueries({ queryKey: ['receptions'] });
      queryClient.invalidateQueries({ queryKey: ['receptions-simple'] });
    },
  });
};

